import { useMemo } from 'react';
import { noop } from 'utils/noop';
import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';
import { colors, spacing } from 'ui/theme';
import { SecondaryButton } from 'ui/button';
import { Delete, MakeCopy, Edit24, Overflow } from 'ui/icons';
// import { WorkflowWebhook } from '../types';

const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

const createActiveOverflowOptions = (
  showCopyModal,
  showArchiveModal,
  editWorkflowWebhook,
) /*: ActionMenuOption[] from ui/actionMenu */ => [
  editWorkflowWebhook
    ? {
        as: 'button',
        content: (
          <>
            <Edit24 height={16} />
            <span>Edit</span>
          </>
        ),
        id: 'edit',
        onClick: editWorkflowWebhook,
      }
    : undefined,
  {
    as: 'button',
    content: (
      <>
        <MakeCopy height={16} />
        <span>Make a copy</span>
      </>
    ),
    id: 'make-a-copy',
    onClick: showCopyModal,
  },
  {
    as: 'button',
    content: (
      <>
        <Delete height={16} />
        <span>Delete</span>
      </>
    ),
    id: 'archive',
    onClick: showArchiveModal,
  },
];

// type Props = {
//   workflowWebhook: WorkflowWebhook,
//   /** Function run that navigates the user to the edit workflow webhook page */
//   editWorkflowWebhook?: () => void,
//   /** Function run that shows the copy modal when Copy button is clicked */
//   showCopyModal: () => void,
//   /** Function run that shows the delete modal when Delete button is clicked */
//   showDeleteModal: () => void,
// };

export const WorkflowWebhookOverflowMenu = ({
  workflowWebhook,
  showCopyModal = noop,
  showDeleteModal = noop,
  editWorkflowWebhook = null,
}) => {
  const safeId = workflowWebhook.id.toString();
  const memoizedOptions = useMemo(
    () =>
      createActiveOverflowOptions(showCopyModal, showDeleteModal, editWorkflowWebhook).filter(
        (o) => o,
      ),
    [safeId],
  );

  return (
    <ActionMenu align="right" options={memoizedOptions}>
      <StyledButton>
        <Overflow color={colors.grey90} />
      </StyledButton>
    </ActionMenu>
  );
};
